import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/auth',
    name: 'Autenticação',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/profile/account/:id_adm/:path?',
    name: 'Perfil',
    component: () => import('@/views/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Usuários',
    component: () => import('@/views/users/List_Users.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users/notas',
    name: 'Nota dos Usuários',
    component: () => import('@/views/users/List_UsersNotas.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users/frequencia',
    name: 'Frequência dos Usuários',
    component: () => import('@/views/users/List_UsersAulas.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_user/',
    name: 'Formulário do Usuário',
    component: () => import('@/views/users/FormUser.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_user/:path?', name: 'editar_user', 
      component: () => import('@/views/users/FormUser.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/avaliacoes/',
    name: 'Avaliações',
    component: () => import('@/views/avaliacoes/List_Avaliacoes.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_avaliacao/',
    name: 'form_avaliacao',
    component: () => import('@/views/avaliacoes/FormAvaliacao.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_avaliacao', 
      name: 'editar_avaliacao', 
      component: () => import('@/views/avaliacoes/FormAvaliacao.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/aulas',
    name: 'Aulas',
    component: () => import('@/views/aulas/List_Aulas.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_aula/',
    name: 'form_aula',
    component: () => import('@/views/aulas/FormAula.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_aula', 
      name: 'editar_aula', 
      component: () => import('@/views/aulas/FormAula.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/banners',
    name: 'Banners',
    component: () => import('@/views/banners/List_Banners.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_banner/',
    name: 'form_banner',
    component: () => import('@/views/banners/FormBanner.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_banner', 
      name: 'editar_banner', 
      component: () => import('@/views/banners/FormBanner.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/edicoes',
    name: 'Edições',
    component: () => import('@/views/edicoes/List_Edicoes.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_edicao/',
    name: 'form_edicao',
    component: () => import('@/views/edicoes/FormEdicao.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_edicao', 
      name: 'editar_edicao', 
      component: () => import('@/views/edicoes/FormEdicao.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/subjects',
    name: 'Disciplinas',
    component: () => import('@/views/subjects/List_Subjects.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_subject/',
    name: 'form_subject',
    component: () => import('@/views/subjects/FormSubject.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_subject', 
      name: 'editar_subject', 
      component: () => import('@/views/subjects/FormSubject.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/categories',
    name: 'Categorias',
    component: () => import('@/views/categories/List_Categories.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_category/',
    name: 'form_category',
    component: () => import('@/views/categories/FormCategory.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_category', 
      name: 'editar_category', 
      component: () => import('@/views/categories/FormCategory.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/authors',
    name: 'Autores',
    component: () => import('@/views/authors/List_Authors.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_author/',
    name: 'form_author',
    component: () => import('@/views/authors/FormAuthor.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_author', 
      name: 'editar_author', 
      component: () => import('@/views/authors/FormAuthor.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/notifications',
    name: 'Notificações',
    component: () => import('@/views/notifications/List_Notifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_notification/',
    name: 'form_notification',
    component: () => import('@/views/notifications/FormNotification.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_notification', 
      name: 'editar_notification', 
      component: () => import('@/views/notifications/FormNotification.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/messages',
    name: 'Mensagens',
    component: () => import('@/views/messages/List_Messages.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-console',
    name: 'Console IA',
    component: () => import('@/views/ai/AIConsole.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-logs',
    name: 'AI Logs',
    component: () => import('@/views/ailogs/List_AILogs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admins',
    name: 'Administradores',
    component: () => import('@/views/admins/List_Admins.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_adm/',
    name: 'Formulário do Administrador',
    component: () => import('@/views/admins/FormAdmin.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_adm/:path?', name: 'editar_adm', 
      component: () => import('@/views/admins/FormAdmin.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/certificates',
    name: 'Certificados',
    component: () => import('@/views/certificates/List_Certificates.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_certificate/',
    name: 'form_certificate',
    component: () => import('@/views/certificates/FormCertificates.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_certificate', 
      name: 'editar_certificate',
      component: () => import('@/views/certificates/FormCertificates.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/live_events',
    name: 'Live Events',
    component: () => import('@/views/live_events/List_LiveEvents.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_live_event/',
    name: 'form_live_event',
    component: () => import('@/views/live_events/FormLiveEvent.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_live_event', 
      name: 'editar_live_event', 
      component: () => import('@/views/live_events/FormLiveEvent.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/calendar',
    name: 'Calendario',
    component: () => import('@/views/calendar/CalendarView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/notificacoes-gerais',
    name: 'Notificações Gerais',
    component: () => import('@/views/notificacoes_gerais/List_NotificacoesGerais.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_notificacao_geral/',
    name: 'form_notificacao_geral',
    component: () => import('@/views/notificacoes_gerais/FormNotificacaoGeral.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_notificacao', 
      name: 'editar_notificacao_geral', 
      component: () => import('@/views/notificacoes_gerais/FormNotificacaoGeral.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('@/views/faq/List_Faq.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_faq/',
    name: 'form_faq',
    component: () => import('@/views/faq/FormFaq.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_faq', 
      name: 'editar_faq', 
      component: () => import('@/views/faq/FormFaq.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/coordenadores',
    name: 'Coordenadores',
    component: () => import('@/views/coordenador/List_Coordenadores.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/form_coordenador/',
    name: 'form_coordenador',
    component: () => import('@/views/coordenador/FormCoordenador.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: ':id_coordenador', 
      name: 'editar_coordenador', 
      component: () => import('@/views/coordenador/FormCoordenador.vue'),
      meta: { requiresAuth: true }
    }]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error 404',
    component: () => import('@/views/Error404.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = !!store.state.user.user

  if (requiresAuth && !isAuthenticated) {
    store.commit('SET_REDIRECT', to.path)
    store.commit('LOG_USER_OUT')
    next({ name: 'Autenticação' })
  } else {
    const titleCase = (str) =>
      str
        .toLowerCase()
        .split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
    
    document.title = `${titleCase(to.name)} | ${process.env.VUE_APP_TITLE}`;
    window.scrollTo(0, 0);
    next();
  }
});


export default router
